export default __webpack_public_path__ + "static/media/signup-page-background.edaa444f.png";